module.exports = __webpack_public_path__ + "media/images/lb/533-8b9cf713a41fe113771a42bf9d3ecd0a.svg";